/**
 * Renders the Combobox by using the data from the page context (API data from dynamic section)
 */
import { ControlProps, RankedTester, rankWith, Test } from '@jsonforms/core';
import { useJsonForms, withJsonFormsOneOfEnumProps } from '@jsonforms/react';
import _ from 'lodash';
import React from 'react';

import { InputComboBox } from '../spectrum-control/InputComboBox';
import { SpectrumInputControl } from './SpectrumInputControl';

export const SpectrumComboBoxControl = (props: ControlProps) => {
  const context = useJsonForms();
  const config = context.config;

  const uischema = props.uischema;
  const dataSource = uischema.options?.dataSource;
  const name = uischema.options?.name;

  const transformData = config?.lifecycleHooks?.comboBox?.transformData;

  if (!dataSource) {
    console.error('dataSource is not defined in the uischema.options');
  }

  let options = [];


  switch (dataSource.type) {
    case 'context':
      const contextKey = dataSource.value;
      if (!contextKey) {
        console.error(
          'Context key is not defined in the uischema.options.dataSource'
        );
      }
      const pageContext = config.pageContext;

      const contextData = _.get(pageContext, contextKey);

      if (!contextData) {
        console.error(`contextData for key '${contextKey}' does not exists`);
        return null;
      }

      if (transformData) {
        options = transformData(name, contextData);
      } else {
        options = contextData;
      }

      break;
    case "static":
      console.error('static data source is not implemented yet');
      // TODO: Implement static data source
      break;
    default:
      console.error('dataSource.type is not defined in the uischema.options');
  }


  return (
    <SpectrumInputControl {...props} options={options} input={InputComboBox} />
  );
};

const isComboBoxTrue: Test.Tester = (uischema: any) =>
  uischema?.options?.comboBox;

export const spectrumComboBoxControlTester: RankedTester = rankWith(
  5,
  isComboBoxTrue
);

export default withJsonFormsOneOfEnumProps(SpectrumComboBoxControl);
